import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../environments/environment';

/**
 * Guard that prevents access to standalone-only routes (e.g. /login) when running
 * in a cloud environment. In cloud, authentication is handled by MSAL — the local
 * login screen should never be rendered.
 */
export const standaloneOnlyGuard: CanActivateFn = () => {
  if (environment.name.includes('cloud')) {
    return inject(Router).createUrlTree(['/']);
  }
  return true;
};
